import { useAppSelector } from './useAppSelector';

/**
 * True when the current user is a Tenant Admin.
 *
 * IMPORTANT: the session `roles` array holds tenant_role_id UUIDs (resolved from membership),
 * NOT role-name strings — so `roles.includes('tenant_admin')` never matches. Tenant-admin
 * identity is instead derived from a permission only that role carries: `tenant:settings:write`
 * (the same signal TenantSettingsPage uses). Centralised here so routing/gating stays correct.
 */
export const useIsTenantAdmin = (): boolean => {
  const permissions = useAppSelector((s) => s.sessionState.permissions);
  return permissions.includes('tenant:settings:write');
};
